/* Syntax compiled to ES2018; source and reproducible build: docs/analysis/2026-11-02-clarity-fixes. */
(function() {
  "use strict";
  var _a;
  const ENABLED = true;
  const EXP = "value_tygrys_v1", KEY = "sp_value_tygrys_v1", WINDOW = 7 * 864e5;
  const qs = new URLSearchParams(location.search), isLanding = /^\/pages\/lista-tygrys\/?$/.test(location.pathname);
  const preview = ["control", "value"].includes(qs.get("sp_value_preview")) ? qs.get("sp_value_preview") : "";
  if (!ENABLED && !preview) return;
  if (!preview && (qs.has("preview_theme_id") || ((_a = window.Shopify) == null ? void 0 : _a.designMode) || qs.get("utm_source") === "codex_qa")) return;
  let record = null;
  const valid = (r) => r && ["control", "value"].includes(r.arm) && /^[0-9a-f-]{36}$/i.test(r.id) && Number.isFinite(r.at) && r.at <= Date.now();
  try {
    if (preview) record = { id: "preview", arm: preview, at: Date.now(), channel: "codex_qa", ad: "", qa: true };
    else {
      record = JSON.parse(localStorage.getItem(KEY) || "null");
      if (!valid(record)) record = null;
      if (!record && isLanding && document.querySelector("[data-sp-value-copy]") && document.getElementById("sp-value-tygrys-template")) {
        record = { id: crypto.randomUUID(), arm: Math.random() < 0.5 ? "control" : "value", at: Date.now(), channel: (qs.get("utm_source") || (/facebook|instagram/i.test(document.referrer) ? "meta" : /google/i.test(document.referrer) ? "google" : "other")).slice(0, 64), ad: (qs.get("ad_id") || qs.get("utm_content") || "").slice(0, 64) };
        localStorage.setItem(KEY, JSON.stringify(record));
      }
    }
  } catch (_) {
    return;
  }
  if (!record) return;
  const active = () => Date.now() - record.at <= WINDOW;
  window.spValueAttrs = () => active() ? { sp_value_exp: EXP, sp_value_arm: record.arm, sp_value_id: record.id, sp_value_qa: preview ? "1" : "0" } : {};
  function send(event, context) {
    var _a2;
    if (preview || !active() || !window.SP_AB_BEACON) return;
    const body = JSON.stringify({ product: EXP, arm: record.arm, src: event, k: record.id, ad: context || record.ad || "", camp: record.channel, path: location.pathname, ts: Date.now() });
    try {
      if (!((_a2 = navigator.sendBeacon) == null ? void 0 : _a2.call(navigator, window.SP_AB_BEACON, new Blob([body], { type: "text/plain" })))) fetch(window.SP_AB_BEACON, { method: "POST", headers: { "Content-Type": "text/plain" }, body, keepalive: true }).catch(() => {
      });
    } catch (_) {
    }
  }
  async function stamp() {
    var _a2, _b;
    if (!active()) return;
    try {
      const r = await fetch((((_b = (_a2 = window.Shopify) == null ? void 0 : _a2.routes) == null ? void 0 : _b.root) || "/") + "cart/update.js", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ attributes: window.spValueAttrs() }) });
      if (!r.ok) return;
      const cart = await r.json();
      document.documentElement.dataset.spValueStamped = String(Object.entries(window.spValueAttrs()).every(([k, v]) => {
        var _a3;
        return ((_a3 = cart.attributes) == null ? void 0 : _a3[k]) === v;
      }));
    } catch (_) {
    }
  }
  document.documentElement.dataset.spValueExp = EXP;
  document.documentElement.dataset.spValueArm = record.arm;
  document.documentElement.dataset.spValuePreview = String(!!preview);
  if (isLanding) {
    const slot = document.querySelector("[data-sp-value-copy]"), tpl = document.getElementById("sp-value-tygrys-template");
    if (!slot || !tpl) return;
    if (record.arm === "value") slot.replaceChildren(tpl.content.cloneNode(true));
    send("view");
    const block = slot.closest(".sp-lista__prod");
    if ("IntersectionObserver" in window) {
      const obs = new IntersectionObserver((entries) => {
        if (entries.some((e) => e.isIntersecting)) {
          send("shown");
          obs.disconnect();
        }
      }, { threshold: 0.25 });
      obs.observe(block);
    }
    document.addEventListener("click", (e) => {
      if (e.target.closest("a[data-sp-cta]")) send("cta");
      if (e.target.closest("[data-sp-value-proof]")) send("proof");
    });
  } else if (location.pathname.startsWith("/products/")) send("pdp");
  stamp();
  document.addEventListener("sp:offer-atc", () => send("atc"));
  const factors = /* @__PURE__ */ new Set();
  function factorsSeen() {
    const offer = typeof window.spOfferAttrs === "function" ? window.spOfferAttrs() : {};
    if (offer.sp_offer_exp && offer.sp_offer_qa !== "1") {
      const ctx = offer.sp_offer_exp + ":" + offer.sp_offer_arm;
      if (!factors.has(ctx)) {
        factors.add(ctx);
        send("selector", ctx);
      }
    }
    const drawer2 = document.querySelector("cart-drawer.active");
    if ((drawer2 == null ? void 0 : drawer2.dataset.spDrawerExp) && drawer2.dataset.spDrawerPreview !== "true") {
      const ctx = drawer2.dataset.spDrawerExp + ":" + drawer2.dataset.spDrawerArm;
      if (!factors.has(ctx)) {
        factors.add(ctx);
        send("drawer", ctx);
      }
    }
  }
  window.addEventListener("load", factorsSeen, { once: true });
  const drawer = document.querySelector("cart-drawer");
  if (drawer) new MutationObserver(factorsSeen).observe(drawer, { attributes: true, attributeFilter: ["class"] });
})();

